module.exports = __webpack_public_path__ + "static/media/WeddingDetails1_tags.35820377.svg";